import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Mail, Youtube, MapPin } from 'lucide-react';
import Card from '../components/ui/Card';
import { useSEO } from '../hooks/useSEO';

export default function Contacts() {
  const { t } = useLanguage();
  useSEO({
    title: 'Contacts',
    description:
      'Get in touch with GRAWEO Charitable Foundation. Contact us for inquiries about humanitarian aid, donations, volunteer opportunities, and partnerships.',
  });

  return (
    <div className="bg-white min-h-screen">
      {/* Hero */}
      <section className="bg-gradient-to-br from-graweo-chocolate to-graweo-olive text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold font-manrope mb-6">
            {t('contacts_title')}
          </h1>
          <p className="text-xl text-gray-100 max-w-2xl mx-auto">
            {t('contacts_subtitle')}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold font-manrope text-gray-900 mb-8">
            {t('footer_contact')}
          </h2>

          <div className="space-y-6">
            <Card className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-graweo-terra/10 to-graweo-tan/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-graweo-terra" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">
                    {t('contact_email')}
                  </h3>
                  <a
                    href="mailto:info@graweo.org"
                    className="text-graweo-terra hover:underline"
                  >
                    info@graweo.org
                  </a>
                  <p className="text-sm text-gray-500 mt-1">
                    For general inquiries and partnerships
                  </p>
                </div>
              </div>
            </Card>

            <Card className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-graweo-olive/10 to-graweo-tan/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Youtube className="w-6 h-6 text-graweo-olive" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">
                    YouTube
                  </h3>
                  <a
                    href="https://youtube.com/@graweo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-graweo-terra hover:underline"
                  >
                    @graweo
                  </a>
                  <p className="text-sm text-gray-500 mt-1">
                    Videos and updates on our channel
                  </p>
                </div>
              </div>
            </Card>

            <Card className="p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-graweo-chocolate/10 to-graweo-olive/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-graweo-chocolate" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">
                    {t('legal_address')}
                  </h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    {t('legal_address_value')}
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
}
